module.exports = __webpack_public_path__ + "static/media/IMG_7782__one.aabcd4f3.jpeg";